import { useEffect, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components"
import PatronForm from '../../views/BackStage/PatronForm'
import { useBorrower } from "../../controllers/BorrowerController";
import { usePatronCategory } from "../../controllers/PatronCategoryController"

import { Row, Col } from '../../../ui/ot'
import { Toaster, toast } from 'sonner'
import { Button } from "../../../ui/ot"
const NewOrEditPatron = ({ }) => {
    const thisJS = "NewPatron"
    const { categorycode } = useParams()
    const { borrowernumber } = useParams()
    const bIsPostMode = !!categorycode
    const bIsPatchMode = !!borrowernumber
    const navigate = useNavigate()
    const formRef = useRef()
    const [modalLoading, setModalLoading] = useState(false)
    const [axiosMode, setAxiosMode] = useState(bIsPostMode ? "post" : (bIsPatchMode ? "patch" : "get"))
    const onFormFinish = (values) => {
        console.log(thisJS, "onFormFinish", axiosMode, values)
        //let newValue = { ...values }
        //let messageData = values?.message || []
        if (axiosMode === "get") { return; }
        if (bIsPostMode) {
            postBorrowerData([{ ...values, manager_id: 1 }])
        } else if (bIsPatchMode) {
            patchBorrowerData([{ ...values, manager_id: 1 }])
        }
    }
    const {
        getBorrowerData,
        postBorrowerData,
        patchBorrowerData,
    } = useBorrower({
        onBefore: ({ axiosMode, values }) => {
            console.log(thisJS, "BorrowerData", axiosMode, "onBefore", values)
            const bIsGet = axiosMode === "get"
            if (!bIsGet) { setModalLoading(true) }
        },
        onFinish: ({ axiosMode, status, values }) => {
            console.log(thisJS, "BorrowerData", axiosMode, "onFinish", status, values)
            const bIsPost = axiosMode === "post"
            const bIsPatch = axiosMode === "patch"
            if (bIsPost || bIsPatch) {
                const cMode = bIsPost ? "新增" : "修改"
                if (status === "success") {
                    toast.success(cMode + "成功");
                    getBorrowerData({
                        borrowernumber
                    })
                        .then((response) => {
                            let datas = response?.data
                            let firstData = datas.find((ele) => true) || []
                            firstData["sex"] = firstData["sex"] ? firstData["sex"] ?? "N" : "N"
                            firstData["password"] = ""
                            formRef.current.setValues(firstData)
                        })
                } else {
                    toast.error(cMode + "失敗");
				}
                setModalLoading(false)
            }
        }
    })
    const {
        getPatronCategoryData,
    } = usePatronCategory({
        onBefore: (axiosMode, values) => {
            console.log(thisJS, "PatronCategoryData", axiosMode, "onBefore", values)
            const bIsGet = axiosMode === "get"
            if (!bIsGet) { setModalLoading(true) }
        },
        onFinish: ({ axiosMode, status, values }) => {
            console.log(thisJS, "PatronCategoryData", axiosMode, "onFinish", status, values)
            const bIsGet = axiosMode === "get"
            if (!bIsGet) { setModalLoading(true) }
        }
    })
    useEffect(() => {
        if (bIsPostMode) {
            getPatronCategoryData({
                categorycode
            })
            .then((response) => {
                let datas = response?.data
                let firstData = datas.find((ele) => true)
                let defaultValue = {}
                defaultValue['manager_id'] = 0
                defaultValue['categorycode'] = firstData['categorycode']
                defaultValue['message'] = firstData['message']
                console.log(thisJS, "PatronCategoryData", axiosMode, "useEffect", defaultValue)
                formRef.current.setValues(defaultValue)
            })
        }       
        if (bIsPatchMode) {
            getBorrowerData({
                borrowernumber
            })
                .then((response) => {
                    console.log(thisJS, "BorrowerData", axiosMode, "useEffect", response, formRef.current.getValues("X"))
                    let datas = response?.data
                    let firstData = datas.find((ele) => true) || []
                    firstData['manager_id'] = 0
                    firstData["sex"] = firstData["sex"] ? firstData["sex"] ?? "N" : "N"
                    firstData["password"] = ""
                    formRef.current.setValues(firstData)
            })
        }       
    }, [ ])
    return (
        <Row gutter={[16, 16]}>
            <Toaster
                richColors
                position="top-center"
            />
            <Col span={24}>
                <Title>{bIsPostMode ? "New" : "Modify patron"}</Title>
            </Col>
            <Col span={24}>
                <Row justify="end">
                    <Col>
                        <ButtonGroup>
                            <Button
                                onClick={() => {
                                    formRef.current.onFormSubmit()
                                }}>儲存</Button>
                            <Button variant="ghost"
                                onClick={() => {
                                    navigate('/library/backstage/Patrons')
                                }}
                            >取消</Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Col>
            <Col span={24}>
                <Row justify="center">
                    <Col span={24}>
                        <PatronForm
                            ref={formRef}
                            defaultQuickMode={bIsPostMode}
                            onFormFinish={onFormFinish}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const Title = styled.div`
text-align: left;
width: 100%;
font-size: 1.6em;
font-weight: 600;
`

const FlexBox = styled.div`
display: flex;
gap: 1em;
`

const VerticalBox = styled.div`
display: flex;
gap: 1em;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.2em;
font-weight: 600;
}
`

const PScontext = styled.div`
font-size: 0.8em;
color: #707070;
text-wrap: nowrap;
align-self: center;

`

const SmallFlexBox = styled.div`
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const ColumnFlexBox = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em10 = styled.div`
width: 10em;
display: flex;
justify-content: flex-start;
align-items: center;
gap: 0.3em;
`

const Em20 = styled.div`
width: 20em;
`

const ButtonGroup = styled.div`
width: 100%;
display: flex;
gap: 1em;
align-items: flex-start;
`

export default NewOrEditPatron